import { render } from "./wemaOrbit.vue?vue&type=template&id=344e4b48&scoped=true"
import script from "./wemaOrbit.vue?vue&type=script&lang=js"
export * from "./wemaOrbit.vue?vue&type=script&lang=js"

import "./wemaOrbit.vue?vue&type=style&index=0&id=344e4b48&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344e4b48"]])

export default __exports__